import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import 'classnames';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import { Popper } from '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import { ProfileCard } from '../../rewards/ProfileCard/index.js';
import styles from './index.module.scss.js';

const LinkCustom = ({
  item,
  setIsOpen
}) => /* @__PURE__ */ React.createElement(
  Link,
  {
    to: item.onClick ? "#" : item.href ?? "#",
    onClick: item.onClick ? (e) => {
      if (item.onClick) {
        e.preventDefault();
        item.onClick?.(e);
      }
      setIsOpen(false);
    } : void 0,
    key: item.href,
    className: item.active ? "active" : ""
  },
  /* @__PURE__ */ React.createElement(Icon, { iconName: item.icon }),
  item.count ? /* @__PURE__ */ React.createElement("span", { className: styles.count }, item.count > 99 ? "99+" : item.count) : null,
  item.name
);
const ProfileModal = ({
  trigger,
  isOpen,
  user,
  links,
  setIsOpen,
  vipWidgetData,
  blockPageScroll = false,
  textCopy,
  nextRevard,
  reward,
  onClickCopyUserId
}) => {
  useEffect(() => {
    if (isOpen) {
      if (blockPageScroll) {
        setTimeout(() => {
          window.document.body?.classList.add("modal-body-block-scroll");
        }, 0);
      } else {
        setTimeout(() => {
          window.document.body?.classList.remove("modal-body-block-scroll");
        }, 0);
      }
    }
    if (!isOpen) {
      window.document.body?.classList.remove("modal-body-block-scroll");
    }
  }, [isOpen, blockPageScroll]);
  const { isMobile, isTablet } = useWindowSize();
  return /* @__PURE__ */ React.createElement(
    Popper,
    {
      trigger,
      triggerClassName: styles.trigger,
      isOpen,
      setIsOpen,
      options: {
        modifiers: [
          { name: "preventOverflow", options: { padding: 13 } },
          {
            name: "offset",
            options: { offset: [16, isMobile || isTablet ? 5 : 15] }
          },
          { name: "shift", options: { enabled: true } },
          {
            name: "flip",
            options: {
              fallbackPlacements: ["top", "right"]
            }
          }
        ]
      }
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.box }, /* @__PURE__ */ React.createElement("div", { className: styles.row }, /* @__PURE__ */ React.createElement(
      ProfileCard,
      {
        ...user,
        ...vipWidgetData,
        text: textCopy,
        level: user.level,
        nextRevard,
        reward,
        onClickCopyUserId: (id) => onClickCopyUserId(id)
      }
    )), /* @__PURE__ */ React.createElement("div", { className: styles.row }, /* @__PURE__ */ React.createElement("div", { className: styles.divider })), /* @__PURE__ */ React.createElement("div", { className: styles.row }, /* @__PURE__ */ React.createElement("div", { className: styles.list }, links.map(
      (item) => "links" in item && Array.isArray(item.links) ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.subTitle }, item.groupName), item.links.map((subItem) => /* @__PURE__ */ React.createElement(
        LinkCustom,
        {
          item: subItem,
          setIsOpen: () => setIsOpen(false)
        }
      ))) : /* @__PURE__ */ React.createElement(LinkCustom, { item, setIsOpen: () => setIsOpen(false) })
    ))))
  );
};
ProfileModal.displayName = "ProfileModal.Modal";

export { ProfileModal };
//# sourceMappingURL=index.js.map
